import { setMixpanelSuperProperties, trackMixpanelEvent } from "./mixpanel";

// ─────────────────────────────────────────────────────────────
// EVENT NAME CONSTANTS  —  SST_<TAB>_<ACTION>
// ─────────────────────────────────────────────────────────────

export const VPEvent = {
  // ── Global ────────────────────────────────────────────────────────────────
  SST_SESSION_STARTED: "SST_SESSION_STARTED",
  SST_SCREEN_VIEWED: "SST_SCREEN_VIEWED",
  SST_NAV_ITEM_CLICKED: "SST_NAV_ITEM_CLICKED",
  SST_BALANCE_ALERT: "SST_BALANCE_ALERT",
  SST_UI_CLICKED: "SST_UI_CLICKED",

  // ── Ledger ────────────────────────────────────────────────────────────────
  SST_LEDGER_SUMMARY_VIEWED: "SST_LEDGER_SUMMARY_VIEWED",
  SST_LEDGER_ORG_CHANGED: "SST_LEDGER_ORG_CHANGED",
  SST_LEDGER_FROM_DATE_CHANGED: "SST_LEDGER_FROM_DATE_CHANGED",
  SST_LEDGER_TO_DATE_CHANGED: "SST_LEDGER_TO_DATE_CHANGED",
  SST_LEDGER_FILTER_APPLIED: "SST_LEDGER_FILTER_APPLIED",
  SST_LEDGER_DOWNLOADED: "SST_LEDGER_DOWNLOADED",
  SST_LEDGER_HOLD_BANNER_VIEWED: "SST_LEDGER_HOLD_BANNER_VIEWED",

  // Card expand/collapse (distinct event per state, not a single toggled event)
  SST_LEDGER_CLOSING_BALANCE_EXPANDED: "SST_LEDGER_CLOSING_BALANCE_EXPANDED",
  SST_LEDGER_CLOSING_BALANCE_COLLAPSED: "SST_LEDGER_CLOSING_BALANCE_COLLAPSED",
  SST_LEDGER_ACCOUNT_PAYABLE_EXPANDED: "SST_LEDGER_ACCOUNT_PAYABLE_EXPANDED",
  SST_LEDGER_ACCOUNT_PAYABLE_COLLAPSED: "SST_LEDGER_ACCOUNT_PAYABLE_COLLAPSED",
  SST_LEDGER_ACCOUNT_RECEIVABLES_EXPANDED: "SST_LEDGER_ACCOUNT_RECEIVABLES_EXPANDED",
  SST_LEDGER_ACCOUNT_RECEIVABLES_COLLAPSED: "SST_LEDGER_ACCOUNT_RECEIVABLES_COLLAPSED",
  SST_LEDGER_DUE_PAYABLE_EXPANDED: "SST_LEDGER_DUE_PAYABLE_EXPANDED",
  SST_LEDGER_DUE_PAYABLE_COLLAPSED: "SST_LEDGER_DUE_PAYABLE_COLLAPSED",
  SST_LEDGER_CALCULATION_EXPANDED: "SST_LEDGER_CALCULATION_EXPANDED",
  SST_LEDGER_CALCULATION_COLLAPSED: "SST_LEDGER_CALCULATION_COLLAPSED",
  SST_LEDGER_DUE_INVOICES_EXPANDED: "SST_LEDGER_DUE_INVOICES_EXPANDED",
  SST_LEDGER_DUE_INVOICES_COLLAPSED: "SST_LEDGER_DUE_INVOICES_COLLAPSED",
  SST_LEDGER_CREDITS_DEBITS_EXPANDED: "SST_LEDGER_CREDITS_DEBITS_EXPANDED",
  SST_LEDGER_CREDITS_DEBITS_COLLAPSED: "SST_LEDGER_CREDITS_DEBITS_COLLAPSED",
  SST_LEDGER_HOLDS_ON_PAYABLE_EXPANDED: "SST_LEDGER_HOLDS_ON_PAYABLE_EXPANDED",
  SST_LEDGER_HOLDS_ON_PAYABLE_COLLAPSED: "SST_LEDGER_HOLDS_ON_PAYABLE_COLLAPSED",
  SST_LEDGER_NEEDS_ACTION_EXPANDED: "SST_LEDGER_NEEDS_ACTION_EXPANDED",
  SST_LEDGER_NEEDS_ACTION_COLLAPSED: "SST_LEDGER_NEEDS_ACTION_COLLAPSED",
  SST_LEDGER_REJECTED_INVOICES_EXPANDED: "SST_LEDGER_REJECTED_INVOICES_EXPANDED",
  SST_LEDGER_REJECTED_INVOICES_COLLAPSED: "SST_LEDGER_REJECTED_INVOICES_COLLAPSED",
  SST_LEDGER_RECONCILIATION_ACTIONS_EXPANDED: "SST_LEDGER_RECONCILIATION_ACTIONS_EXPANDED",
  SST_LEDGER_RECONCILIATION_ACTIONS_COLLAPSED: "SST_LEDGER_RECONCILIATION_ACTIONS_COLLAPSED",
  SST_LEDGER_OTHER_ISSUES_EXPANDED: "SST_LEDGER_OTHER_ISSUES_EXPANDED",
  SST_LEDGER_OTHER_ISSUES_COLLAPSED: "SST_LEDGER_OTHER_ISSUES_COLLAPSED",

  // Tile / leaf clicks (one distinct event per tile)
  SST_LEDGER_AP_INVOICES_CLICKED: "SST_LEDGER_AP_INVOICES_CLICKED",
  SST_LEDGER_AP_PAYMENT_MADE_CLICKED: "SST_LEDGER_AP_PAYMENT_MADE_CLICKED",
  SST_LEDGER_AP_PR_RTV_CLICKED: "SST_LEDGER_AP_PR_RTV_CLICKED",
  SST_LEDGER_AP_BRAND_PROMO_CLICKED: "SST_LEDGER_AP_BRAND_PROMO_CLICKED",
  SST_LEDGER_AP_PAYMENT_IN_PROGRESS_CLICKED: "SST_LEDGER_AP_PAYMENT_IN_PROGRESS_CLICKED",
  SST_LEDGER_AP_ADS_VISIBILITY_CLICKED: "SST_LEDGER_AP_ADS_VISIBILITY_CLICKED",
  SST_LEDGER_AP_TDS_CLICKED: "SST_LEDGER_AP_TDS_CLICKED",
  SST_LEDGER_AP_OTHER_ENTRIES_CLICKED: "SST_LEDGER_AP_OTHER_ENTRIES_CLICKED",
  SST_LEDGER_AR_INVOICES_RAISED_CLICKED: "SST_LEDGER_AR_INVOICES_RAISED_CLICKED",
  SST_LEDGER_AR_PAYMENT_RECEIVED_CLICKED: "SST_LEDGER_AR_PAYMENT_RECEIVED_CLICKED",
  SST_LEDGER_AR_CREDIT_NOTE_RECEIVED_CLICKED: "SST_LEDGER_AR_CREDIT_NOTE_RECEIVED_CLICKED",
  SST_LEDGER_OVERDUE_INVOICES_CLICKED: "SST_LEDGER_OVERDUE_INVOICES_CLICKED",
  SST_LEDGER_DUE_PR_RTV_CLICKED: "SST_LEDGER_DUE_PR_RTV_CLICKED",
  SST_LEDGER_DUE_ADS_VISIBILITY_CLICKED: "SST_LEDGER_DUE_ADS_VISIBILITY_CLICKED",
  SST_LEDGER_DUE_BRAND_PROMOS_CLICKED: "SST_LEDGER_DUE_BRAND_PROMOS_CLICKED",
  SST_LEDGER_DUE_TDS_CLICKED: "SST_LEDGER_DUE_TDS_CLICKED",
  SST_LEDGER_DUE_OTHER_ENTRIES_CLICKED: "SST_LEDGER_DUE_OTHER_ENTRIES_CLICKED",
  SST_LEDGER_DUE_ADVANCE_PAYMENT_CLICKED: "SST_LEDGER_DUE_ADVANCE_PAYMENT_CLICKED",
  SST_LEDGER_RESOLVE_HOLDS_CLICKED: "SST_LEDGER_RESOLVE_HOLDS_CLICKED",
  SST_LEDGER_HOLD_GST_CLICKED: "SST_LEDGER_HOLD_GST_CLICKED",
  SST_LEDGER_HOLD_PR_RTV_CLICKED: "SST_LEDGER_HOLD_PR_RTV_CLICKED",
  SST_LEDGER_HOLD_EVENTS_CLICKED: "SST_LEDGER_HOLD_EVENTS_CLICKED",
  SST_LEDGER_HOLD_ADS_VISIBILITY_CLICKED: "SST_LEDGER_HOLD_ADS_VISIBILITY_CLICKED",
  SST_LEDGER_HOLD_BDPO_CLICKED: "SST_LEDGER_HOLD_BDPO_CLICKED",
  SST_LEDGER_HOLD_ADHOC_OTHER_CLICKED: "SST_LEDGER_HOLD_ADHOC_OTHER_CLICKED",
  SST_LEDGER_REJECTED_INVOICE_AMOUNT_CLICKED: "SST_LEDGER_REJECTED_INVOICE_AMOUNT_CLICKED",
  SST_LEDGER_ACTION_ON_HOLDS_CLICKED: "SST_LEDGER_ACTION_ON_HOLDS_CLICKED",
  SST_LEDGER_RECON_PENDING_ON_VENDOR_CLICKED: "SST_LEDGER_RECON_PENDING_ON_VENDOR_CLICKED",
  SST_LEDGER_RECON_PENDING_ON_US_CLICKED: "SST_LEDGER_RECON_PENDING_ON_US_CLICKED",
  SST_LEDGER_OTHER_ISSUES_PENDING_ON_VENDOR_CLICKED: "SST_LEDGER_OTHER_ISSUES_PENDING_ON_VENDOR_CLICKED",
  SST_LEDGER_OTHER_ISSUES_PENDING_ON_US_CLICKED: "SST_LEDGER_OTHER_ISSUES_PENDING_ON_US_CLICKED",

  // ── Holds ─────────────────────────────────────────────────────────────────
  SST_HOLDS_SECTION_VIEWED: "SST_HOLDS_SECTION_VIEWED",
  SST_HOLDS_RESOLUTION_VIEWED: "SST_HOLDS_RESOLUTION_VIEWED",
  SST_HOLDS_CATEGORY_OPENED: "SST_HOLDS_CATEGORY_OPENED",
  SST_HOLDS_DETAIL_SEARCHED: "SST_HOLDS_DETAIL_SEARCHED",

  // ── Invoice Rejection ─────────────────────────────────────────────────────
  SST_INVOICE_REJECTION_VIEWED: "SST_INVOICE_REJECTION_VIEWED",
  SST_INVOICE_REJECTION_TAB_SWITCHED: "SST_INVOICE_REJECTION_TAB_SWITCHED",
  SST_INVOICE_REJECTION_SUBFILTER_APPLIED: "SST_INVOICE_REJECTION_SUBFILTER_APPLIED",
  SST_INVOICE_REJECTION_TAKE_ACTION_CLICKED: "SST_INVOICE_REJECTION_TAKE_ACTION_CLICKED",
  SST_INVOICE_REJECTION_COPY_UPLOAD_CLICKED: "SST_INVOICE_REJECTION_COPY_UPLOAD_CLICKED",
  SST_INVOICE_REJECTION_COPY_VIEWED: "SST_INVOICE_REJECTION_COPY_VIEWED",
  SST_INVOICE_REJECTION_MORE_INFO_EXPANDED: "SST_INVOICE_REJECTION_MORE_INFO_EXPANDED",
  SST_INVOICE_REJECTION_ACTION_COMPLETED: "SST_INVOICE_REJECTION_ACTION_COMPLETED",
  SST_INVOICE_REJECTION_DOWNLOADED: "SST_INVOICE_REJECTION_DOWNLOADED",
  SST_INVOICE_REJECTION_HELP_CLICKED: "SST_INVOICE_REJECTION_HELP_CLICKED",

  // ── Recon ─────────────────────────────────────────────────────────────────
  SST_RECON_SUMMARY_VIEWED: "SST_RECON_SUMMARY_VIEWED",
  SST_RECON_DISPUTE_ENTRIES_VIEWED: "SST_RECON_DISPUTE_ENTRIES_VIEWED",
  SST_RECON_RAISE_OTHER_ISSUES_VIEWED: "SST_RECON_RAISE_OTHER_ISSUES_VIEWED",
  SST_RECON_ISSUE_BUCKET_OPENED: "SST_RECON_ISSUE_BUCKET_OPENED",
  SST_RECON_DISPUTED_ROW_ACTION_CLICKED: "SST_RECON_DISPUTED_ROW_ACTION_CLICKED",
  SST_RECON_DISPUTED_ENTRY_UPDATED: "SST_RECON_DISPUTED_ENTRY_UPDATED",
  SST_RECON_ENTRY_COMMENT_OPENED: "SST_RECON_ENTRY_COMMENT_OPENED",
  SST_RECON_DISPUTED_BULK_ACTION: "SST_RECON_DISPUTED_BULK_ACTION",
  SST_RECON_DISPUTED_ENTRIES_DOWNLOADED: "SST_RECON_DISPUTED_ENTRIES_DOWNLOADED",
  SST_RECON_ADD_NEW_ISSUE_CLICKED: "SST_RECON_ADD_NEW_ISSUE_CLICKED",
  SST_RECON_ISSUE_TYPE_TAB_SWITCHED: "SST_RECON_ISSUE_TYPE_TAB_SWITCHED",
  SST_RECON_ISSUE_ENTRY_MODE_SWITCHED: "SST_RECON_ISSUE_ENTRY_MODE_SWITCHED",
  SST_RECON_ISSUE_FIELD_FOCUSED: "SST_RECON_ISSUE_FIELD_FOCUSED",
  SST_RECON_ISSUE_DOC_UPLOADED: "SST_RECON_ISSUE_DOC_UPLOADED",
  SST_RECON_ISSUE_SUBMITTED: "SST_RECON_ISSUE_SUBMITTED",
  SST_RECON_BULK_TEMPLATE_DOWNLOADED: "SST_RECON_BULK_TEMPLATE_DOWNLOADED",
  SST_RECON_BULK_ISSUES_UPLOADED: "SST_RECON_BULK_ISSUES_UPLOADED",

  // ── Early Payment ─────────────────────────────────────────────────────────
  SST_EARLY_PAYMENT_VIEWED: "SST_EARLY_PAYMENT_VIEWED",
  SST_EARLY_PAYMENT_PROGRAM_CARD_VIEWED: "SST_EARLY_PAYMENT_PROGRAM_CARD_VIEWED",
  SST_EARLY_PAYMENT_FIELD_FOCUSED: "SST_EARLY_PAYMENT_FIELD_FOCUSED",
  SST_EARLY_PAYMENT_GST_CERT_UPLOADED: "SST_EARLY_PAYMENT_GST_CERT_UPLOADED",
  SST_EARLY_PAYMENT_SUBMITTED: "SST_EARLY_PAYMENT_SUBMITTED",
  SST_EARLY_PAYMENT_FAQ_OPENED: "SST_EARLY_PAYMENT_FAQ_OPENED",

  // ── FAQ ───────────────────────────────────────────────────────────────────
  SST_FAQ_VIEWED: "SST_FAQ_VIEWED",
  SST_FAQ_SECTION_OPENED: "SST_FAQ_SECTION_OPENED",
} as const;

export type VPEventType = typeof VPEvent[keyof typeof VPEvent];

// ─────────────────────────────────────────────────────────────
// SUPER PROPERTIES  —  auto-attach to every event
// ─────────────────────────────────────────────────────────────

export interface VPSuperProps {
  vendor_pan: string;
  brand_name: string;
  environment: string;
  portal: "vendor_portal";
  theme: string;
}

/** Call once right after identifyVendorPortalUser() */
export function setVendorPortalSuperProps(props: VPSuperProps) {
  setMixpanelSuperProperties({
    vendor_pan: props.vendor_pan,
    brand_name: props.brand_name,
    environment: props.environment,
    portal: props.portal,
    theme: props.theme,
  });
}

// ─────────────────────────────────────────────────────────────
// TYPED TRACKER FUNCTIONS
// ─────────────────────────────────────────────────────────────

// ── Global ────────────────────────────────────────────────────────────────

/** TRIGGER: VendorPortalLayout — after identifyVendorPortalUser() on every session init */
export function trackSessionStarted() {
  trackMixpanelEvent(VPEvent.SST_SESSION_STARTED);
}

/** TRIGGER: Every page/route mount — useEffect on location.pathname change */
export function trackScreenViewed(props: {
  screen_name: string;
  theme?: string;
  path?: string;
  referrer_screen?: string;
}) {
  trackMixpanelEvent(VPEvent.SST_SCREEN_VIEWED, props);
}

/** TRIGGER: onClick of any sidebar nav item in VendorPortalLayout */
export function trackNavItemClicked(props: { nav_item: string }) {
  trackMixpanelEvent(VPEvent.SST_NAV_ITEM_CLICKED, props);
}

/** TRIGGER: AlertsComponent — on mount (viewed) or onClick of alert CTA (clicked) */
export function trackBalanceAlert(props: { action: "viewed" | "clicked" }) {
  trackMixpanelEvent(VPEvent.SST_BALANCE_ALERT, props);
}

/** TRIGGER: Any generic button/link click not covered by a specific event */
export function trackUIClicked(props: { element: string; screen_name?: string; theme?: string }) {
  trackMixpanelEvent(VPEvent.SST_UI_CLICKED, props);
}

// ── Ledger ────────────────────────────────────────────────────────────────

/** TRIGGER: LedgerSummaryVendorPortal — useEffect on mount */
export function trackLedgerSummaryViewed() {
  trackMixpanelEvent(VPEvent.SST_LEDGER_SUMMARY_VIEWED);
}

/** TRIGGER: LedgerSummaryVendorPortal — onChange of the organisation Autocomplete */
export function trackLedgerOrgChanged(props: { org_selected: string }) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_ORG_CHANGED, props);
}

/** TRIGGER: LedgerSummaryVendorPortal — onChange of the "From" DatePicker */
export function trackLedgerFromDateChanged(props: { date?: string }) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_FROM_DATE_CHANGED, props);
}

/** TRIGGER: LedgerSummaryVendorPortal — onChange of the "To" DatePicker */
export function trackLedgerToDateChanged(props: { date?: string }) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_TO_DATE_CHANGED, props);
}

/** TRIGGER: LedgerSummaryVendorPortal — on Apply / date-range change */
export function trackLedgerFilterApplied(props: {
  org_selected?: string;
  from_date?: string;
  to_date?: string;
  date_range_days?: number;
}) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_FILTER_APPLIED, props);
}

/** TRIGGER: LedgerSummaryVendorPortal — onClick of Download button */
export function trackLedgerDownloaded(props: { date_range_days?: number; file_format?: string }) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DOWNLOADED, props);
}

/** TRIGGER: LedgerSummaryVendorPortal — renders when a vendor is on full-payment hold */
export function trackLedgerHoldBannerViewed(props?: { reason?: string }) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_BANNER_VIEWED, props);
}

// ── Ledger: card expand/collapse (one function per card, distinct event per state) ─────────

export function trackClosingBalanceToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_CLOSING_BALANCE_EXPANDED : VPEvent.SST_LEDGER_CLOSING_BALANCE_COLLAPSED
  );
}

export function trackAccountPayableToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_ACCOUNT_PAYABLE_EXPANDED : VPEvent.SST_LEDGER_ACCOUNT_PAYABLE_COLLAPSED
  );
}

export function trackAccountReceivablesToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_ACCOUNT_RECEIVABLES_EXPANDED : VPEvent.SST_LEDGER_ACCOUNT_RECEIVABLES_COLLAPSED
  );
}

export function trackDuePayableToggled(expanded: boolean) {
  trackMixpanelEvent(expanded ? VPEvent.SST_LEDGER_DUE_PAYABLE_EXPANDED : VPEvent.SST_LEDGER_DUE_PAYABLE_COLLAPSED);
}

export function trackCalculationToggled(expanded: boolean) {
  trackMixpanelEvent(expanded ? VPEvent.SST_LEDGER_CALCULATION_EXPANDED : VPEvent.SST_LEDGER_CALCULATION_COLLAPSED);
}

export function trackDueInvoicesToggled(expanded: boolean) {
  trackMixpanelEvent(expanded ? VPEvent.SST_LEDGER_DUE_INVOICES_EXPANDED : VPEvent.SST_LEDGER_DUE_INVOICES_COLLAPSED);
}

export function trackCreditsDebitsToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_CREDITS_DEBITS_EXPANDED : VPEvent.SST_LEDGER_CREDITS_DEBITS_COLLAPSED
  );
}

export function trackHoldsOnPayableToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_HOLDS_ON_PAYABLE_EXPANDED : VPEvent.SST_LEDGER_HOLDS_ON_PAYABLE_COLLAPSED
  );
}

export function trackNeedsActionToggled(expanded: boolean) {
  trackMixpanelEvent(expanded ? VPEvent.SST_LEDGER_NEEDS_ACTION_EXPANDED : VPEvent.SST_LEDGER_NEEDS_ACTION_COLLAPSED);
}

export function trackRejectedInvoicesToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_REJECTED_INVOICES_EXPANDED : VPEvent.SST_LEDGER_REJECTED_INVOICES_COLLAPSED
  );
}

export function trackReconciliationActionsToggled(expanded: boolean) {
  trackMixpanelEvent(
    expanded ? VPEvent.SST_LEDGER_RECONCILIATION_ACTIONS_EXPANDED : VPEvent.SST_LEDGER_RECONCILIATION_ACTIONS_COLLAPSED
  );
}

export function trackOtherIssuesToggled(expanded: boolean) {
  trackMixpanelEvent(expanded ? VPEvent.SST_LEDGER_OTHER_ISSUES_EXPANDED : VPEvent.SST_LEDGER_OTHER_ISSUES_COLLAPSED);
}

// ── Ledger: tile / leaf clicks (one function per tile) ──────────────────────────────────────

interface LedgerTileClickProps {
  tile_amount?: number;
  entry_count?: number;
  [key: string]: unknown;
}

export function trackAPInvoicesClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_INVOICES_CLICKED, props);
}

export function trackAPPaymentMadeClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_PAYMENT_MADE_CLICKED, props);
}

export function trackAPPrRtvClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_PR_RTV_CLICKED, props);
}

export function trackAPBrandPromoClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_BRAND_PROMO_CLICKED, props);
}

export function trackAPPaymentInProgressClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_PAYMENT_IN_PROGRESS_CLICKED, props);
}

export function trackAPAdsVisibilityClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_ADS_VISIBILITY_CLICKED, props);
}

export function trackAPTdsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_TDS_CLICKED, props);
}

export function trackAPOtherEntriesClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AP_OTHER_ENTRIES_CLICKED, props);
}

export function trackARInvoicesRaisedClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AR_INVOICES_RAISED_CLICKED, props);
}

export function trackARPaymentReceivedClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AR_PAYMENT_RECEIVED_CLICKED, props);
}

export function trackARCreditNoteReceivedClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_AR_CREDIT_NOTE_RECEIVED_CLICKED, props);
}

export function trackOverdueInvoicesClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_OVERDUE_INVOICES_CLICKED, props);
}

export function trackDuePrRtvClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DUE_PR_RTV_CLICKED, props);
}

export function trackDueAdsVisibilityClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DUE_ADS_VISIBILITY_CLICKED, props);
}

export function trackDueBrandPromosClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DUE_BRAND_PROMOS_CLICKED, props);
}

export function trackDueTdsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DUE_TDS_CLICKED, props);
}

export function trackDueOtherEntriesClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DUE_OTHER_ENTRIES_CLICKED, props);
}

export function trackDueAdvancePaymentClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_DUE_ADVANCE_PAYMENT_CLICKED, props);
}

export function trackResolveHoldsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_RESOLVE_HOLDS_CLICKED, props);
}

export function trackHoldGSTClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_GST_CLICKED, props);
}

export function trackHoldPrRtvClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_PR_RTV_CLICKED, props);
}

export function trackHoldEventsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_EVENTS_CLICKED, props);
}

export function trackHoldAdsVisibilityClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_ADS_VISIBILITY_CLICKED, props);
}

export function trackHoldBDPOClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_BDPO_CLICKED, props);
}

export function trackHoldAdhocOtherClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_HOLD_ADHOC_OTHER_CLICKED, props);
}

export function trackRejectedInvoiceAmountClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_REJECTED_INVOICE_AMOUNT_CLICKED, props);
}

export function trackActionOnHoldsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_ACTION_ON_HOLDS_CLICKED, props);
}

export function trackReconPendingOnVendorClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_RECON_PENDING_ON_VENDOR_CLICKED, props);
}

export function trackReconPendingOnUsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_RECON_PENDING_ON_US_CLICKED, props);
}

export function trackOtherIssuesPendingOnVendorClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_OTHER_ISSUES_PENDING_ON_VENDOR_CLICKED, props);
}

export function trackOtherIssuesPendingOnUsClicked(props: LedgerTileClickProps) {
  trackMixpanelEvent(VPEvent.SST_LEDGER_OTHER_ISSUES_PENDING_ON_US_CLICKED, props);
}

// ── Holds ─────────────────────────────────────────────────────────────────

/** TRIGGER: LedgerSummaryVendorPortal — when Holds section scrolls into view / renders */
export function trackHoldsSectionViewed(props: { total_hold_amount?: number; hold_buckets_with_data?: number }) {
  trackMixpanelEvent(VPEvent.SST_HOLDS_SECTION_VIEWED, props);
}

/** TRIGGER: HoldResolutionVendorPortal — useEffect on mount */
export function trackHoldsResolutionViewed() {
  trackMixpanelEvent(VPEvent.SST_HOLDS_RESOLUTION_VIEWED);
}

/** TRIGGER: HoldResolutionVendorPortal — onClick of a hold category row/card */
export function trackHoldsCategoryOpened(props: {
  hold_category: string;
  hold_amount?: number;
  entry_count?: number;
  bucket?: string;
}) {
  trackMixpanelEvent(VPEvent.SST_HOLDS_CATEGORY_OPENED, props);
}

/** TRIGGER: HoldResolutionVendorPortal — onChange of search input or filter dropdown */
export function trackHoldsDetailSearched(props: { search_term?: string; filter_applied?: string }) {
  trackMixpanelEvent(VPEvent.SST_HOLDS_DETAIL_SEARCHED, props);
}

// ── Invoice Rejection ─────────────────────────────────────────────────────

/** TRIGGER: RejectedInvoicesVendorPortal — useEffect on mount */
export function trackInvoiceRejectionViewed() {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_VIEWED);
}

/** TRIGGER: RejectedInvoicesVendorPortal — onClick of tab (e.g. Pending / Resolved) */
export function trackInvoiceRejectionTabSwitched(props: { tab: string }) {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_TAB_SWITCHED, props);
}

/** TRIGGER: RejectedInvoicesVendorPortal — onChange of subfilter chip/dropdown */
export function trackInvoiceRejectionSubfilterApplied(props: { subfilter: string }) {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_SUBFILTER_APPLIED, props);
}

/** TRIGGER: VendorPortalRejectedInvoicesResolveModal — onClick of "Take Action" button */
export function trackInvoiceRejectionTakeActionClicked(props: {
  issue_category: string;
  invoice_number?: string;
  grn_amount?: number;
  resolution_status?: string;
}) {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_TAKE_ACTION_CLICKED, props);
}

/** TRIGGER: VendorPortalRejectedInvoicesResolveModal — onClick of "Upload Invoice Copy" */
export function trackInvoiceRejectionCopyUploadClicked(props: { file_selected?: boolean; issue_category?: string }) {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_COPY_UPLOAD_CLICKED, props);
}

/** TRIGGER: VendorPortalRejectedInvoicesResolveModal — onClick of invoice copy preview link */
export function trackInvoiceRejectionCopyViewed() {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_COPY_VIEWED);
}

/** TRIGGER: RejectedInvoicesVendorPortal — onClick of "More Info" / expand row */
export function trackInvoiceRejectionMoreInfoExpanded(props: { section: string }) {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_MORE_INFO_EXPANDED, props);
}

/** TRIGGER: VendorPortalRejectedInvoicesResolveModal — after API call resolves (success/failure) */
export function trackInvoiceRejectionActionCompleted(props: { action_type: string; success: boolean }) {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_ACTION_COMPLETED, props);
}

/** TRIGGER: RejectedInvoicesVendorPortal — onClick of Download button */
export function trackInvoiceRejectionDownloaded() {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_DOWNLOADED);
}

/** TRIGGER: RejectedInvoicesVendorPortal — onClick of Help / FAQ icon */
export function trackInvoiceRejectionHelpClicked() {
  trackMixpanelEvent(VPEvent.SST_INVOICE_REJECTION_HELP_CLICKED);
}

// ── Recon ─────────────────────────────────────────────────────────────────

/** TRIGGER: ReconciliationVendorPortal — useEffect on mount */
export function trackReconSummaryViewed() {
  trackMixpanelEvent(VPEvent.SST_RECON_SUMMARY_VIEWED);
}

/** TRIGGER: VpDisputedEntries (isNonReconViewPage=false) — useEffect on mount */
export function trackReconDisputeEntriesViewed(props: { render_ok?: boolean; has_data?: boolean }) {
  trackMixpanelEvent(VPEvent.SST_RECON_DISPUTE_ENTRIES_VIEWED, props);
}

/** TRIGGER: VpDisputedEntries (isNonReconViewPage=true) — useEffect on mount */
export function trackReconRaiseOtherIssuesViewed() {
  trackMixpanelEvent(VPEvent.SST_RECON_RAISE_OTHER_ISSUES_VIEWED);
}

/** TRIGGER: TicketBucketedTable / VpFilterOfDisputedEntries — onClick of bucket accordion */
export function trackReconIssueBucketOpened(props: {
  issue_bucket: string;
  bucket_amount?: number;
  bucket_count?: number;
}) {
  trackMixpanelEvent(VPEvent.SST_RECON_ISSUE_BUCKET_OPENED, props);
}

/** TRIGGER: VpTakeActionDisputedEntries — onClick of row action button (Approve / Reject / Escalate) */
export function trackReconDisputedRowActionClicked(props: {
  action_type: string;
  invoice_amount?: number;
  disputed_amount?: number;
  dependency?: string;
}) {
  trackMixpanelEvent(VPEvent.SST_RECON_DISPUTED_ROW_ACTION_CLICKED, props);
}

/** TRIGGER: VpTakeActionDisputedEntries — after API call resolves (success/failure) */
export function trackReconDisputedEntryUpdated(props: { entry_id: string; success: boolean }) {
  trackMixpanelEvent(VPEvent.SST_RECON_DISPUTED_ENTRY_UPDATED, props);
}

/** TRIGGER: TicketCommentsCell — onClick of comment icon / open comments panel */
export function trackReconEntryCommentOpened() {
  trackMixpanelEvent(VPEvent.SST_RECON_ENTRY_COMMENT_OPENED);
}

/** TRIGGER: VpBulkActionDisputedEntries — on row checkbox select or bulk action button click */
export function trackReconDisputedBulkAction(props: { selected_count: number; bulk_action: string }) {
  trackMixpanelEvent(VPEvent.SST_RECON_DISPUTED_BULK_ACTION, props);
}

/** TRIGGER: VpDisputedEntries — onClick of Download button */
export function trackReconDisputedEntriesDownloaded() {
  trackMixpanelEvent(VPEvent.SST_RECON_DISPUTED_ENTRIES_DOWNLOADED);
}

/** TRIGGER: VpDisputedEntries — onClick of "Add New Issue" button */
export function trackReconAddNewIssueClicked(props: { org_selected?: string }) {
  trackMixpanelEvent(VPEvent.SST_RECON_ADD_NEW_ISSUE_CLICKED, props);
}

/** TRIGGER: VpDisputedEntries / Non-Recon — onClick of issue type tab */
export function trackReconIssueTypeTabSwitched(props: { issue_type_tab: string }) {
  trackMixpanelEvent(VPEvent.SST_RECON_ISSUE_TYPE_TAB_SWITCHED, props);
}

/** TRIGGER: VpDisputedEntries — onClick of Manual / Bulk toggle */
export function trackReconIssueEntryModeSwitched(props: { mode: string }) {
  trackMixpanelEvent(VPEvent.SST_RECON_ISSUE_ENTRY_MODE_SWITCHED, props);
}

/** TRIGGER: VpDisputedEntries form — onFocus of any input field */
export function trackReconIssueFieldFocused(props: { field_name: string }) {
  trackMixpanelEvent(VPEvent.SST_RECON_ISSUE_FIELD_FOCUSED, props);
}

/** TRIGGER: VpUploadDocument — after file chosen in file input */
export function trackReconIssueDocUploaded(props: { doc_type?: string; file_selected?: boolean }) {
  trackMixpanelEvent(VPEvent.SST_RECON_ISSUE_DOC_UPLOADED, props);
}

/** TRIGGER: VpDisputedEntries — onClick of Submit / Confirm button, after API resolves */
export function trackReconIssueSubmitted(props: {
  issue_type: string;
  has_pod?: boolean;
  confirmed?: boolean;
  success: boolean;
}) {
  trackMixpanelEvent(VPEvent.SST_RECON_ISSUE_SUBMITTED, props);
}

/** TRIGGER: VpDisputedEntries bulk mode — onClick of "Download Template" */
export function trackReconBulkTemplateDownloaded(props: { issue_type_tab: string }) {
  trackMixpanelEvent(VPEvent.SST_RECON_BULK_TEMPLATE_DOWNLOADED, props);
}

/** TRIGGER: VpDisputedEntries bulk mode — after bulk file uploaded, API resolves */
export function trackReconBulkIssuesUploaded(props: { issue_type_tab: string; row_count?: number; success: boolean }) {
  trackMixpanelEvent(VPEvent.SST_RECON_BULK_ISSUES_UPLOADED, props);
}

// ── Early Payment ─────────────────────────────────────────────────────────

/** TRIGGER: EarlyPaymentVendorPortal — useEffect on mount */
export function trackEarlyPaymentViewed(props: { enrolment_state: string }) {
  trackMixpanelEvent(VPEvent.SST_EARLY_PAYMENT_VIEWED, props);
}

/** TRIGGER: EarlyPaymentVendorPortal — when program card renders with rate info */
export function trackEarlyPaymentProgramCardViewed(props: { enrolment_state: string; displayed_rate_pa?: string }) {
  trackMixpanelEvent(VPEvent.SST_EARLY_PAYMENT_PROGRAM_CARD_VIEWED, props);
}

/** TRIGGER: EarlyPaymentVendorPortal form — onFocus of any input field */
export function trackEarlyPaymentFieldFocused(props: { field_name: string }) {
  trackMixpanelEvent(VPEvent.SST_EARLY_PAYMENT_FIELD_FOCUSED, props);
}

/** TRIGGER: EarlyPaymentVendorPortal — after GST cert file chosen in file input */
export function trackEarlyPaymentGSTCertUploaded(props: { file_selected?: boolean }) {
  trackMixpanelEvent(VPEvent.SST_EARLY_PAYMENT_GST_CERT_UPLOADED, props);
}

/** TRIGGER: EarlyPaymentVendorPortal — onClick of Submit, after API resolves */
export function trackEarlyPaymentSubmitted(props: {
  credit_period?: string;
  has_gst_cert?: boolean;
  success: boolean;
}) {
  trackMixpanelEvent(VPEvent.SST_EARLY_PAYMENT_SUBMITTED, props);
}

/** TRIGGER: EarlyPaymentVendorPortal — onClick of FAQ link/button */
export function trackEarlyPaymentFAQOpened() {
  trackMixpanelEvent(VPEvent.SST_EARLY_PAYMENT_FAQ_OPENED);
}

// ── FAQ ───────────────────────────────────────────────────────────────────

/** TRIGGER: FaqVendorPortal — useEffect on mount */
export function trackFAQViewed() {
  trackMixpanelEvent(VPEvent.SST_FAQ_VIEWED);
}

/** TRIGGER: FaqVendorPortal — onClick of accordion section / question item */
export function trackFAQSectionOpened(props: { module: string; question: string }) {
  trackMixpanelEvent(VPEvent.SST_FAQ_SECTION_OPENED, props);
}
